const ACTIONS_BY_STATUS = {
  concept: ["review"],
  nog_te_koppelen: ["review"],
  gekoppeld: ["review", "approve", "reject"],
  requested: ["review", "approve", "reject"],
  under_review: ["approve", "reject"],
  approval_pending: ["approve", "reject"],
  approved: ["order", "close"],
  approved_for_ordering: ["order", "close"],
  besteld: ["receive_partial", "receive", "close"],
  opgehaald: ["receive", "close"],
  ontvangen: ["close"],
  ordered: ["receive_partial", "receive", "close"],
  partially_received: ["receive_partial", "receive", "close"],
  received: ["close"],
  gecontroleerd: ["close"],
};

const ACTION_LABELS = {
  review: "In review",
  approve: "Goedkeuren",
  reject: "Afkeuren",
  order: "Intern als besteld markeren",
  receive_partial: "Deels ontvangen",
  receive: "Ontvangen",
  close: "Sluiten",
};

export function getProcurementActionsForStatus(status) {
  return ACTIONS_BY_STATUS[String(status || "").trim()] || [];
}

export function getProcurementActionLabel(actionKey) {
  return ACTION_LABELS[actionKey] || actionKey;
}
